module.exports = __webpack_public_path__ + "img/dealdesk.3f3c70ec.png";